// Fix for environment.prod.ts file
// Define a comprehensive type for the window.env object
declare global {
  interface Window {
    env?: {
      apiUrl?: string;
      uiUrl?: string;
      slaUrl?: string;
      idleTimeout?: string;
      gitCommitRef?: string;
      gitCommitId?: string;
      gitCommitTimestamp?: string;
      askMeEnabled?: string | boolean;
      clientId?: string;
      authority?: string;
      redirectUrl?: string;
      [key: string]: unknown;
    };
    idleWarningTimeout?: string;
  }
}

export const environment = {
  production: true,
  apiUrl: window.env?.apiUrl || "https://api.myapp.local",
  uiUrl: window.env?.uiUrl || "https://ui.myapp.local",
  slaUrl: window.env?.slaUrl || "https://slaUrl.myapp.local",
  idleTimeout: window.env?.idleTimeout || "240",
  idleWarningTimeout: window.idleWarningTimeout || "60",
  gitCommitRef: window.env?.gitCommitRef || "local",
  gitCommitId: window.env?.gitCommitId || "0000000",
  gitCommitTimestamp: window.env?.gitCommitTimestamp || "1980-01-01T00:00:00.000Z",
  enableDebug: false,
  // askMeEnabled: window.env?.askMeEnabled === true,
    askMeEnabled: ((): boolean => {
    const value = window.env?.askMeEnabled;
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value.toLowerCase() === "true";
    return false;
  })(),
  msalConfig: {
    auth: {
      clientId: window.env?.clientId || "abcd",
      authority: window.env?.authority || "https://api.myapp.local",
      redirectUrl: window.env?.redirectUrl || "https://api.myapp.local",
      azureAuthUrl: "https://graph.microsoft.com/me"
    }
  },
};